export default __webpack_public_path__ + "img/dalia.7b2b1bf9.jpg";